// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"ac65c2e0","182":"9fc511be","674":"0005d6e0","775":"5be8e54c","828":"0c469c39"}[chunkId] + ".chunk.js";
};